export default __webpack_public_path__ + "static/process-automation-c84587f6997655161d3391d607debca1.png";